import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { Me } from '@/api/types';
import { useToken } from './session';

export function useMe() {
    const token = useToken();
    return useQuery({
        queryKey: ['me', token],
        queryFn: () => api.get<{ ok: boolean; user: Me }>('/auth/me').then((r) => r.user),
        enabled: !!token,
        staleTime: 5 * 60_000,
        retry: false,
    });
}

export function canManage(me: Me | undefined) {
    return me?.role === 'ADMIN' || me?.role === 'MANAGER';
}
